import { Income, NetIncomeType, patchUpdateDeclaredIncome } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { NetIncomeDetailsForm } from '@/components/modules/DeclaredIncome/components/NetIncomeDetailsForm';
import {
  NetIncomeDetailsFormSchema,
  NetIncomeDetailsFormType,
} from '@/components/modules/DeclaredIncome/schemas/NetIncomeDetailsFormSchema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { useRequest } from '@/hooks/requests/useRequest';

interface NetIncomeEditDialogProps {
  income: Income;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  refresh: () => void;
}
export const NetIncomeEditDialog = ({ income, opened, setOpened, toggleDialog, refresh }: NetIncomeEditDialogProps) => {
  const { request, loading } = useRequest();

  const onSubmitForm = async (useFormValues: NetIncomeDetailsFormType) => {
    await request(patchUpdateDeclaredIncome, {
      id: income.id,
      netIncomeType: useFormValues.netIncomeType as NetIncomeType,
      monthlyNetIncomeAmount: Number(useFormValues.monthlyNetIncome),
      annualNetIncomeAmount: Number(useFormValues.annualNetIncome),
      monthlyNetIncomeCurrency: income.netIncome.monthlyNetIncome.currency,
      annualNetIncomeCurrency: income.netIncome.annualNetIncome.currency,
    });
    await refresh();
    setOpened(false);
  };

  const netIncomeDetailsDefaultValues = {
    annualNetIncome: income.netIncome.annualNetIncome.amount.toString(),
    monthlyNetIncome: income.netIncome.monthlyNetIncome.amount.toString(),
    netIncomeType: income.netIncome.netIncomeType,
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'EDIT_DECLARED_INCOME'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={NetIncomeDetailsFormSchema}
      defaultValues={netIncomeDetailsDefaultValues}
    >
      <NetIncomeDetailsForm income={income} fieldVariant={FieldVariant.form} fullWidth />
    </EditDialogWrapper>
  );
};
